const mobileMenuButton = document.querySelector('#mobile-menu-button');
const navMenu = document.querySelector('#nav-menu');
const navLinks = navMenu.querySelectorAll('li > a');

const navMenuBarIcon = mobileMenuButton.querySelector('.menubar-icon');
const navMenuCloseIcon = mobileMenuButton.querySelector('.close-icon');

const openMenu = () => {
    navMenuBarIcon.classList.add('hidden');
    navMenuCloseIcon.classList.remove('hidden');
    navMenu.classList.remove('hidden');
    navMenu.classList.add('opacity-100', 'scale-y-100');
    mobileMenuButton.setAttribute('aria-expanded', true);
}

const closeMenu = () => {
    navMenuBarIcon.classList.remove('hidden');
    navMenuCloseIcon.classList.add('hidden');
    navMenu.classList.add('hidden');
    navMenu.classList.remove('opacity-100', 'scale-y-100');
    mobileMenuButton.setAttribute('aria-expanded', false);
}

// Handle mobile menu toggle
mobileMenuButton.addEventListener('click', () => {
    const isExpanded = mobileMenuButton.getAttribute('aria-expanded') === 'true';
    isExpanded ? closeMenu() : openMenu();
});

// Close menu on link click (only on mobile)
navLinks.forEach(link => {
    link.addEventListener('click', () => {
        if (window.innerWidth < 1024) {
            closeMenu();
        }
    });
});

// Debounced window resize
let resizeTimeout;
const handleWindowResize = () => {
    clearTimeout(resizeTimeout);

    resizeTimeout = setTimeout(() => {
        const windowWidth = window.innerWidth;
        if (windowWidth >= 1024 && navMenu.classList.contains('hidden')) {
            openMenu();
        } else if (windowWidth < 1024 && !navMenu.classList.contains('hidden')) {
            closeMenu();
        }
    }, 200);
};
window.addEventListener('resize', handleWindowResize);
